
import { useTranslation } from 'react-i18next'

const DrunkParentEnd = (props) => {
  const { t } = useTranslation()
  
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1920 1080"
      role="image"
      aria-labelledby="drunk-parent-end-title"
      {...props}
    >
      <title id="drunk-parent-start-title">{t('antagonists:drunkparent:components:end')}</title>
      <style>
        {
          '.st1{fill:#940c3b}.st3{fill:#e2a972}.st5{fill:#6b5738}.st6{fill:#2e425b}.st7{fill:#00a074}.st9{fill:#00a79b}'
        }
      </style>
      <g id="drunk-parent-a">
        <path
          className="st1"
          d="M1546.6 846.7c8.1 10.5-7.8 229.6-12.3 293.5-4.7 66.9-33.7 268.7-33.7 268.7s41.5 24 73.6 23.4c32.1-.7 66.7-13.6 66.7-13.6s-5.3-170.7 5.1-249.3c10.5-78.6 32.6-292.5 24-343.6-8.6-51.1-41.3-103.9-41.3-103.9s-28.8 17.7-62.8 25.3-78.6 9-78.6 9l59.3 90.5z"
        />
        <path
          className="st1"
          d="M1427.7 919.7c-7.3 36.3 13.8 151.8-3.2 213.6-17.7 64.7-99.4 266.3-99.4 266.3s35.7 38.9 67.3 44.5c31.6 5.6 49.6-5.2 49.6-5.2s46.6-163.5 72.2-238.5 73-279 74.5-330.8c1.5-51.8-4-111.5-4-111.5s-31.7 11.7-66.5 12.6c-34.8.9-78.9-6.5-78.9-6.5l-11.6 155.5z"
        />
        <path
          d="M1562.6 251.2c-6.3-2.5-11.8-5.3-21.8-3.9S1526 253 1526 253l14.4 3.2s-21.8 1.8-30.6 12.8c-8.9 11-9.6 17.8-9.6 17.8l8.1-5.3s-9.2 9.2-10.3 19.9c-1.1 10.7 12.3 75.2 12.3 75.2s112.9 3.4 110.3-4.4c-.7-2.1 6.7-33.2 8.2-41.7s4.8-16.3 2.2-23.1c-2.6-6.7-5.2-14.2-5.2-14.2l7.4 6s-4.4-19.9-12.6-25.2c-8.1-5.3-15.1-4.6-15.1-4.6s3-5.7 7-5c4.1.7 7.4.4 7.4.4s-2.6-8.5-14.8-8.9c-12.2-.4-17.7 1.4-17.7 1.4s1.9-5-5.2-8.2c-7-3.2-19.6 2.1-19.6 2.1z"
          style={{
            fill: '#eee5db',
          }}
        />
        <path
          className="st3"
          d="M1567.1 438.1c24-4.6 33.5-19.9 41-28.2 7.6-8.4 3.9-25.4 5.6-26.8 1.8-1.5 7.9 2.9 14-10.9 6-13.8 9.4-29.3 3.3-29.3-6.3 0-8.8 7-10.7 12.9-1.9 5.8-5.3 13.1-5.3 13.1l-4.5.8s4-26.9-3.2-45.7c-7.2-18.9-7.9-25.8-14.3-23.6s7.5 19.2 7.5 19.2-14.9 1.8-25.4-8.3c-10.6-10.2-14.5-13.8-14.5-13.8s-1.1 3.3.8 8.3c1.9 5.1 4.9 9.1 4.9 9.1s-12.8 1.1-21.1-4.7c-8.3-5.8-11.7-10.9-11.7-10.9s1.9 5.8 1.9 13.1-4.8 10-4.8 10-.1-1.6-.9-4.9c-.8-3.3-2.3-6.2-2.3-6.2s-4.9 11.8-7.2 20.7c-2.2 8.9 3.2 38.9 3.2 38.9l-4.1-.7s-10.7-30.9-17.5-29.1c-6.8 1.8-2.6 18.9-.4 27.2 2.3 8.3 5.3 15.2 9.4 15.6 4.1.4 7.1-.1 7.5.7.4.8 0 18.1 4.9 25.8s23.4 24.7 29.4 25.8c6.1.9 10.7 2.6 14.5 1.9z"
        />
        <path
          className="st3"
          d="M1522.4 384.5s10.2 32.9.2 51c-6.5 11.7-23.8 15.5-35.6 18.2-12.3 2.8-33.6 4.6-33.6 4.6l4.2 67.1 188.7-6.3-8.6-37.4s-24.5-18.8-30.6-29.8c-14.7-26.1-2.3-63-2.3-63l-82.4-4.4z"
        />
        <path
          d="M1547.7 402.6c-.3 3.9 2.3 5.3 3.8 6.4 2.2 1.6 6.1 5.6 11 5.9 5.3.3 9.3-3.6 11-5.1 2.2-2 5.4-4.2 5.1-6.9-.3-2.7-6.1-4-7.9-5-2.8-1.5-6 .4-7.7.2-1.7-.3-4.7-1.5-8.2.1-3.5 1.5-6.9 1.1-7.1 4.4z"
          style={{
            fill: '#d88b46',
          }}
        />
        <path
          className="st5"
          d="M1576.1 337.8s11.4-2 18.9.5c7.5 2.5 9.4 6.2 9.4 6.2l-1.7 3s-2.9-2.5-10.4-4.6c-10-2.9-14.6-1-14.6-1l-1.6-4.1zM1554.5 344.1l-.1-4.1s-10.6-4.5-19.3-2.4c-8.7 2.1-10.3 6-10.3 6l1.8 2.8s4.5-4.6 12.4-4.1c7.8.3 15.5 1.8 15.5 1.8z"
        />
        <path
          className="st6"
          d="M1540.8 353.2c-2.5.9-3.7 3.2-2.8 5.6.9 2.4 2.9 2.9 5.2 2.3 2.7-.8 4.3-3.6 3-6-1.3-2.3-2.8-2.8-5.4-1.9z"
        />
        <path
          className="st6"
          d="m1535.7 356.2 14-3.1-.3-3.3-14.3 1.9zM1587.3 352.7c2.5.9 3.7 3.2 2.8 5.6-.9 2.4-3.2 3-5.5 2.3-2.7-.8-3.4-3-2.7-5.6.5-1.7 2.8-3.2 5.4-2.3z"
        />
        <path className="st6" d="m1592.9 356.8-14.5-3.4 1.1-3.5 14.1 2z" />
        <path
          className="st7"
          d="M1458.2 603.4s-1.2 74.8-.8 96.6c.4 21.7-17.2 57.7-51.6 64.2-34.5 6.4-45.8-77.8-41-105.3 7.6-43.7 37.2-152.5 45.3-175 7.8-21.5 33.7-30.2 44.6-16.9 14.7 17.7 3.5 136.4 3.5 136.4z"
        />
        <path
          className="st7"
          d="M1510.2 446.4s38.4 21.7 69.1 23.9c30.8 2.1 33.4-11.6 33.4-11.6s19.2 9.4 38.6 20.9c14.3 8.5 37.8 26 40.3 43.6 2.1 14.9-28.5 97.4-24.3 145.4 4.3 47.9 29.6 128.1 30.2 146.2 1.6 49.8-7.8 58.9-7.8 58.9l-5.8 44.4s-63.1-1.5-141.1.7c-78 2.1-131.7-21.3-131.7-21.3l6.2-29.5s-20.9-23.6-12.3-50.1c8.6-26.5 19.3-93.9 20.7-122.5 1.4-28.6-3.8-71-9.6-115.4-5.7-44.4-7.9-110.9 17.9-118.1 25.8-7.2 44.6-8.6 54.6-10 10.1-1.7 21.7-5.5 21.6-5.5z"
        />
        <defs>
          <path
            id="SVGID_1_"
            d="M1510.2 446.4s38.4 21.7 69.1 23.9c30.8 2.1 33.4-11.6 33.4-11.6s19.2 9.4 38.6 20.9c14.3 8.5 37.8 26 40.3 43.6 2.1 14.9-28.5 97.4-24.3 145.4 4.3 47.9 29.6 128.1 30.2 146.2 1.6 49.8-7.8 58.9-7.8 58.9l-5.8 44.4s-63.1-1.5-141.1.7c-78 2.1-131.7-21.3-131.7-21.3l6.2-29.5s-20.9-23.6-12.3-50.1c8.6-26.5 19.3-93.9 20.7-122.5 1.4-28.6-3.8-71-9.6-115.4-5.7-44.4-7.9-110.9 17.9-118.1 25.8-7.2 44.6-8.6 54.6-10 10.1-1.7 21.7-5.5 21.6-5.5z"
          />
        </defs>
        <clipPath id="SVGID_00000147939751352653565890000007740427346370919831_">
          <use
            xlinkHref="#SVGID_1_"
            style={{
              overflow: 'visible',
            }}
          />
        </clipPath>
        <g
          style={{
            clipPath:
            'url(#SVGID_00000147939751352653565890000007740427346370919831_)',
          }}
        >
          <path
            className="st9"
            d="M1544.3 472.4c23.8 11 54.7 10.5 67.6 2.5 18.5-11.6 23.2-32.3 23.2-32.3l-16.4-32.5-117.3-2.1-36 26.8s54.8 26.5 78.9 37.6zM1710.1 870.2c-91.9 18.3-138.1 15.9-177.1 17-87.7 2.5-147.7-36.5-147.7-36.5l-11.1 74.2 336.4 11.9-.5-66.6z"
          />
        </g>
        <path
          className="st3"
          d="M1519.8 573.5s.1-16.5.8-21.3 4.1-20.5 5.3-24c1.2-3.5 20.6-20.7 20.6-20.7s5.8 3.2 5.7 9.5c-.1 6.3-12 11.5-11.2 16.9.6 4.2 4.4 3.6 5.7-.1 1.3-3.8 7.3-18 8-20.1.7-2.1-2.8-10.5-2.8-14.8 0-4.2 6.1-7.2 6.1-7.2s12.4 9.4 13.6 11.9c1.2 2.5-1 7.2 1.1 8.8 2.1 1.6 6.7 6.8 5.6 9.8-1 3 2.3 4.7 3.3 7.8 1 3.1-1.8 6 .4 7.6 2.1 1.6 5.9 5.4 6 7.8.1 2.4-7 19.6-10.2 25-5.4 9-18 17.8-19.9 21.8-2.1 4.4-7.4 23.4-7.4 23.4l-37.3-12c.2.2 4.9-22.5 6.6-30.1z"
        />
        <path
          className="st7"
          d="M1388.2 731.2c-10.4-14.6-3.7-35.2 8.8-47.1 12.5-11.9 33.6-44.3 60.1-68.7s40-27.2 40-27.2l20.9-23.9 43.9 30.5-14.9 30.3s12.8 19.9-11.5 47.1c-24.2 27.3-81.2 66.1-102 80.3-15.6 10.8-22.2 11.1-45.3-21.3z"
        />
        <defs>
          <path
            id="SVGID_00000049926635529271823210000013371332966332788616_"
            d="M1388.2 731.2c-10.4-14.6-3.7-35.2 8.8-47.1 12.5-11.9 33.6-44.3 60.1-68.7s40-27.2 40-27.2l20.9-23.9 43.9 30.5-14.9 30.3s12.8 19.9-11.5 47.1c-24.2 27.3-81.2 66.1-102 80.3-15.6 10.8-22.2 11.1-45.3-21.3z"
          />
        </defs>
        <clipPath id="SVGID_00000082352026323897391840000016215708314908041652_">
          <use
            xlinkHref="#SVGID_00000049926635529271823210000013371332966332788616_"
            style={{
              overflow: 'visible',
            }}
          />
        </clipPath>
        <path
          className="st9"
          d="M1491.7 585.3s12.9 9 29.5 24c16.5 14.9 48.1 28.8 55.3 50.7l10.7-61.2-57.9-50.1-37.6 36.6z"
          style={{
            clipPath:
            'url(#SVGID_00000082352026323897391840000016215708314908041652_)',
          }}
        />
        <path
          className="st3"
          d="M1648.4 914.1s-5.3 15.6-6.1 20.4c-.8 4.8-2.7 20.7-2.7 24.4 0 3.7 7.2 32.2 7.2 32.2s6.5-1.2 8.5-7.1c2-6-2.1-20.7.5-25.6 2-3.8 5.4-2 5.4 2s1.1 19.4 1.1 21.6c0 2.3-6.1 9.1-7.5 13-1.4 4 3.4 8.8 3.4 8.8s14.8-4.9 16.7-6.9c2-2 1.4-7.1 4-8 2.6-.9 8.5-4.3 8.5-7.4 0-3.1 3.7-3.7 5.7-6.3 2-2.6.3-6.2 2.8-7.1 2.6-.9 7.4-3.2 8.2-5.4s-.4-20.8-1.6-27c-1.2-6.2-11.2-22.3-11.8-27.1s.6-24.5.6-24.5l-39.2-.7c-.1 0-2.9 23-3.7 30.7z"
        />
        <path
          className="st7"
          d="M1619.5 618.3s30.5 100 29.3 121.7c-1.2 21.7 77.1 40.2 77.1 40.2s-11.1-85.5-14-113.3c-2.9-28.5 1-121.3-19.1-149.4-31-43.3-57.7-45.3-57.7-45.3l-15.6 146.1z"
        />
        <path
          className="st7"
          d="M1670.1 656.7c-17.8 2.1-20.3 70.2-20.7 87.4-.4 17.2-4.4 72.4-4.5 108.3-.2 36 6 37.5 6 37.5l-3.4 25.6 55.1 7.9 10.1-35.2c-.4.2 15.2-12.3 20.8-49.4 5.5-36.1-14.4-103-17.9-128-2.7-18.5-6-58.9-45.5-54.1z"
        />
        <defs>
          <path
            id="SVGID_00000164509294954932405310000011759062786451796901_"
            d="M1670.1 656.7c-17.8 2.1-20.3 70.2-20.7 87.4-.4 17.2-4.4 72.4-4.5 108.3-.2 36 6 37.5 6 37.5l-3.4 25.6 55.1 7.9 10.1-35.2c-.4.2 15.2-12.3 20.8-49.4 5.5-36.1-14.4-103-17.9-128-2.7-18.5-6-58.9-45.5-54.1z"
          />
        </defs>
        <clipPath id="SVGID_00000083807188913593783730000016455656409961056396_">
          <use
            xlinkHref="#SVGID_00000164509294954932405310000011759062786451796901_"
            style={{
              overflow: 'visible',
            }}
          />
        </clipPath>
        <path
          className="st9"
          d="M1640.3 882s14.7.9 37 3.1c22.1 2.1 39.2 1.5 47.8 2.3l-11.5 47.6-76.1-9 2.8-44z"
          style={{
            clipPath:
            'url(#SVGID_00000083807188913593783730000016455656409961056396_)',
          }}
        />
      </g>
    </svg>
  )
}

export default DrunkParentEnd